import {
    AppstoreAddOutlined,
    AuditOutlined,
    BarChartOutlined,
    BookOutlined,
    CalculatorOutlined,
    CalendarOutlined,
    CheckSquareOutlined,
    ClusterOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DashboardOutlined,
    DatabaseOutlined,
    DollarOutlined,
    FileTextOutlined,
    FlagOutlined,
    GlobalOutlined,
    HddOutlined,
    LaptopOutlined,
    LayoutOutlined,
    OrderedListOutlined,
    PercentageOutlined,
    ScheduleOutlined,
    SettingOutlined,
    ShopOutlined,
    ShoppingOutlined,
    SlidersOutlined,
    SnippetsOutlined,
    SortDescendingOutlined,
    TagOutlined,
    TagsOutlined,
    UserAddOutlined,
    VideoCameraOutlined
} from "@ant-design/icons";
import {
    FaRegBuilding,
    FaUserCog,
    FaUserGraduate,
    FaUsers,
} from "react-icons/fa";
import { RiUserFill } from "react-icons/ri";

import { BsBuilding } from "react-icons/bs";
import { SiGoogleclassroom } from "react-icons/si";

const franchiseeNavTree = [
    {
        key: "franchiseeTree",
        path: "",
        title: "Geral",
        icon: "",
        breadcrumb: false,
        submenu: [
            {
                key: "dashboard-global",
                path: "/dashboard/",
                title: "Dashboard",
                icon: DashboardOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: "franchise-suport.index",
                path: "/suport/index",
                title: "Suporte",
                icon: DatabaseOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "service-calls.index",
                        path: "/suport/calls/index",
                        title: "Chamados",
                        icon: FileTextOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "service-calls.index",
                                path: "/suport/calls/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "service-calls.store",
                                path: "/suport/calls/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "franchise-suport.service-call-sectors.index",
                                path: "/suport/service-call-sectors/index",
                                title: "Departamentos",
                                icon: DatabaseOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "franchise-suport.areas.index",
                        path: "/suport/areas/index",
                        title: "Áreas",
                        icon: DatabaseOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    //           {
                    //             key: "franchise-suport.reviews.index",
                    //             path: "/suport/reviews/index",
                    //             title: "Solicitações",
                    //             icon: DollarOutlined,
                    //             breadcrumb: false,
                    //             submenu: [
                    //               {
                    //                 key: "franchise-suport.index",
                    //                 path: "/suport/reviews/index",
                    //                 title: "Listar",
                    //                 icon: OrderedListOutlined,
                    //                 breadcrumb: false,
                    //                 submenu: [],
                    //               },
                    //               {
                    //                 key: "franchise-suport.store",
                    //                 path: "/suport/reviews/store",
                    //                 title: "Criar",
                    //                 icon: AppstoreAddOutlined,
                    //                 breadcrumb: false,
                    //                 submenu: [],
                    //               }
                    //
                    //             ],
                    //           }
                ],
            },
            {
                key: "franchise-charge.index",
                path: "/franchise-charges/index",
                title: "Painel de Cobrança",
                icon: DollarOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: "franchise-website.index",
                path: "/mywebsite",
                title: "Meu Site",
                icon: GlobalOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                // nota fiscal
                key: "invoices",
                path: "/invoices/",
                title: "Gestão de Notas Fiscais",
                icon: SnippetsOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "invoices.index",
                        path: "/invoices/index",
                        title: "Emitidas",
                        icon: SnippetsOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "nfse.index",
                                path: "/invoices/services/index",
                                title: "N.F de Serviço",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "nfe.index",
                                path: "/invoices/products/index",
                                title: "N.F de Produto",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "invoices",
                        permissions: ["nfse.store", "nfe.store"],
                        path: "/invoices/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            // {
            //   key: "royalties",
            //   path: "/royalties/",
            //   title: "Gestão de Royalties e Fundo de Marca",
            //   icon: PercentageOutlined,
            //   breadcrumb: false,
            //   submenu: [
            //     {
            //       key: "royalties.reports",
            //       path: "/royalties/reports",
            //       title: "Relatórios",
            //       icon: OrderedListOutlined,
            //       breadcrumb: false,
            //       submenu: [
            //         {
            //           key: "royalties.reports.index",
            //           path: "/royalties/reports/index",
            //           title: "Listar",
            //           icon: OrderedListOutlined,
            //         }
            //       ],
            //     },
            //   ]
            // },

            {
                key: "franchises",
                path: "/franchises/",
                title: "Franquias",
                icon: ShopOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "franchises.index",
                        path: "/franchises/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "franchises.store",
                        path: "/franchises/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    // {
                    //   key: "multi-franchises",
                    //   path: "/multi-franchises/",
                    //   title: "Multifranquias",
                    //   icon: FaUsers,
                    //   breadcrumb: false,
                    //   submenu: [
                    //     {
                    //       key: "multi-franchises.index",
                    //       path: "/multfranchisee/index",
                    //       title: "Listar",
                    //       icon: OrderedListOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //     {
                    //       key: "multi-franchises.store",
                    //       path: "/multfranchisee/store",
                    //       title: "Criar",
                    //       icon: AppstoreAddOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //   ],
                    // },
                ],
            },
            {
                key: "marketing",
                path: "/marketing/",
                title: "Marketing e Relacionamentos",
                icon: ShopOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "follow-ups",
                        path: "/follow-ups",
                        title: "Follow Ups",
                        icon: BarChartOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "follow-ups.index",
                                path: "/follow-ups/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "follow-ups.store",
                                path: "/follow-ups/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "interested",
                        path: "/interesteds/",
                        title: "Interessados",
                        icon: ShoppingOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "interesteds.index",
                                path: "/interesteds/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "interesteds.store",
                                path: "/interesteds/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "campaigns",
                        path: "/campaigns/",
                        title: "Campanha",
                        icon: FlagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "campaigns.index",
                                path: "/campaigns/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "campaigns.store",
                                path: "/campaigns/store",
                                title: "Criar Campanha",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "contact-channels",
                        path: "/contact-channel/",
                        title: "Canais de contato",
                        icon: CommentOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "contact-channels.index",
                                path: "/contact-channels/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "contact-channels.store",
                                path: "/contact-channels/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "calendar",
                        path: "/calendar/",
                        title: "Calendário",
                        icon: CalendarOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "school-calendar.index",
                                path: "/school-calendar/index",
                                title: "Calendário Letivo",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "calendar-events",
                                path: "/calendar/",
                                title: "Eventos/Feriados",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "calendar-events.index",
                                        path: "/calendar/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "calendar-events.store",
                                        path: "/calendar/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },

                            {
                                key: "calendar-events-types",
                                path: "/event-types/",
                                title: "Tipos de Eventos",
                                icon: TagOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "calendar-events-types.index",
                                        path: "/event-types/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "calendar-events-types.store",
                                        path: "/event-types/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },

            {
                key: "courses",
                path: "/courses/",
                title: "Cursos",
                icon: VideoCameraOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "courses.index",
                        path: "/courses/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "courses.store",
                        path: "/courses/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    // {
                    //   key: "CourseGroups",
                    //   path: "/course/course-groups/",
                    //   title: "Grupo de cursos",
                    //   icon: InsertRowBelowOutlined,
                    //   breadcrumb: false,
                    //   submenu: [
                    //     {
                    //       key: "CourseGroupsList",
                    //       path: "/course/course-groups/index",
                    //       title: "Listar",
                    //       icon: OrderedListOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //     {
                    //       key: "CourseGroupsCreate",
                    //       path: "/course/course-groups/store",
                    //       title: "Criar",
                    //       icon: AppstoreAddOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //   ],
                    // },
                    // {
                    //   key: "TargetAudience",
                    //   path: "/course/target-audience/",
                    //   title: "Público alvo",
                    //   icon: TagOutlined,
                    //   breadcrumb: false,
                    //   submenu: [
                    //     {
                    //       key: "TargetAudienceList",
                    //       path: "/course/target-audiences/index",
                    //       title: "Listar",
                    //       icon: OrderedListOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //     {
                    //       key: "TargetAudienceCreate",
                    //       path: "/course/target-audiences/store",
                    //       title: "Criar",
                    //       icon: AppstoreAddOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //   ],
                    // },
                    {
                        key: "course-categories",
                        path: "/course-categories/",
                        title: "Categorias",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "course-categories.index",
                                path: "/course-categories/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "course-categories.store",
                                path: "/course-categories/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "course-sub-categories",
                        path: "/course-sub-categories/",
                        title: "Subcategorias",
                        icon: TagsOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "course-sub-categories.index",
                                path: "/course-sub-categories/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "course-sub-categories.store",
                                path: "/course-sub-categories/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    // {
                    //   key: "CourseTrail",
                    //   path: "/course/trail/",
                    //   title: "Trilha",
                    //   icon: IoTrailSignOutline,
                    //   breadcrumb: false,
                    //   submenu: [
                    //     {
                    //       key: "CourseTrailList",
                    //       path: "/course/trail/index",
                    //       title: "Listar",
                    //       icon: OrderedListOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //     {
                    //       key: "CourseTrailCreate",
                    //       path: "/course/trail/store",
                    //       title: "Criar",
                    //       icon: AppstoreAddOutlined,
                    //       breadcrumb: false,
                    //       submenu: [],
                    //     },
                    //   ],
                    // },
                    {
                        key: "levelings-management",
                        path: "/leveling/",
                        title: "Nívelamento",
                        icon: SortDescendingOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "levelings",
                                path: "/levelings/",
                                title: "Nível de cat.",
                                icon: TagOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "levelings.index",
                                        path: "/levelings/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "levelings.store",
                                        path: "/levelings/store",
                                        title: "Cadastrar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "leveling-categories",
                                path: "/leveling-categories/",
                                title: "Cat. de questionários",
                                icon: TagOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "leveling-categories.index",
                                        path: "/leveling-categories/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "leveling-categories.store",
                                        path: "/leveling-categories/store",
                                        title: "Cadastrar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },

                    {
                        key: "evaluations",
                        path: "/evaluation/",
                        title: "Avaliações",
                        icon: CheckSquareOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "evaluations.index",
                                path: "/evaluation/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "evaluations.store",
                                path: "/evaluation/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "evaluation-methods",
                                path: "/evaluation-methods/",
                                title: "Métodos de Avaliação",
                                icon: AuditOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-methods.index",
                                        path: "/evaluation-methods/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "evaluation-methods.store",
                                        path: "/evaluation-methods/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "evaluation-types",
                                path: "/evaluation-types/",
                                title: "Tipos de Avaliação",
                                icon: BookOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-types.index",
                                        path: "/evaluation-types/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "evaluation-types.store",
                                        path: "/evaluation-types/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "evaluation-grades",
                                path: "/evaluation-grades/",
                                title: "Notas",
                                icon: CalculatorOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "evaluation-grades.index",
                                        path: "/evaluation-grades/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "evaluation-grades.store",
                                        path: "/evaluation-grades/store",
                                        title: "Lançar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        key: "class-management",
                        path: "/class-management/",
                        title: "Gestão de aulas",
                        icon: CalendarOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "team-schedules.index",
                                path: "/team-schedule/",
                                title: "Agenda de aulas",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // tipos de eventos
                            // {
                            //   key: "any",
                            //   path: "/any/",
                            //   title: "Lançamento de Presença",
                            //   icon: TagOutlined,
                            //   breadcrumb: false,
                            //   submenu: [
                            //     {
                            //       key: "any.index",
                            //       path: "/event-types/index",
                            //       title: "Listar",
                            //       icon: OrderedListOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //     {
                            //       key: "any.store",
                            //       path: "/any/store",
                            //       title: "Criar",
                            //       icon: AppstoreAddOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //   ],
                            // },
                        ],
                    },

                    {
                        key: "periods",
                        path: "/periods/",
                        title: "Período Acadêmico",
                        icon: ScheduleOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "periods.index",
                                path: "/periods/index",
                                title: "Período Letivo",
                                icon: CalendarOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "periods.index",
                                        path: "/periods/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "periods.store",
                                        path: "/periods/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            // {
                            //   key: "course-periods",
                            //   path: "/course-periods/",
                            //   title: "Estágio",
                            //   icon: VideoCameraOutlined,
                            //   breadcrumb: false,
                            //   submenu: [
                            //     {
                            //       key: "course-periods.index",
                            //       path: "/course-periods/index",
                            //       title: "Listar",
                            //       icon: OrderedListOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //     {
                            //       key: "course-periods.store",
                            //       path: "/course-periods/store",
                            //       title: "Criar",
                            //       icon: AppstoreAddOutlined,
                            //       breadcrumb: false,
                            //       submenu: [],
                            //     },
                            //   ],
                            // },
                        ],
                    },

                    {
                        key: "discount-management",
                        path: "/discount-management/",
                        title: "Desconto e Promoções",
                        icon: PercentageOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "scholarships",
                                path: "/discount-management/scholarships/",
                                title: "Bolsas",
                                icon: ShoppingOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "scholarships.index",
                                        path: "/discount-management/scholarship/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "scholarships.store",
                                        path: "/discount-management/scholarship/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                key: "configure-profiles",
                path: "/configure-profiles/",
                title: "Gestão de Usuários",
                icon: AuditOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "profile-management",
                        path: "/profile-management/",
                        title: "Gerenciar perfis",
                        icon: FaUserCog,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "profile-managements.index",
                                path: "/profile-management/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "profile-management-create",
                            //   path: "/profile-management/store",
                            //   title: "Criar",
                            //   icon: AppstoreAddOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                        ],
                    },
                    {
                        key: "roles",
                        path: "/roles",
                        title: "Perfis e Permissões",
                        icon: UserAddOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "roles.index",
                                path: "/roles/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "roles.store",
                                path: "/roles/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "users",
                        path: "/users/",
                        title: "Usuários",
                        icon: RiUserFill,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "users.index",
                                path: "/users/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "users.store",
                                path: "/users/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "students",
                        path: "/students",
                        title: "Alunos",
                        icon: FaUserGraduate,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "students.index",
                                path: "/students/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: "enrollments",
                path: "/enrollments/",
                title: "Matrículas",
                icon: FaUserGraduate,
                breadcrumb: false,
                submenu: [
                    {
                        key: "enrollments.index",
                        path: "/enrollments/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "enrollments.store",
                        path: "/enrollments/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            {
                key: "teams",
                path: "/teams/",
                title: "Turmas",
                icon: FaUsers,
                breadcrumb: false,
                submenu: [
                    {
                        key: "teams.index",
                        path: "/teams/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "teams.store",
                        path: "/teams/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            {
                key: "products",
                path: "/products/",
                title: "Gestão de Produtos",
                icon: ShoppingOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "products.index",
                        path: "/products/index",
                        title: "Listar",
                        icon: OrderedListOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "products.store",
                        path: "/products/store",
                        title: "Criar",
                        icon: AppstoreAddOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                    {
                        key: "product-categories",
                        path: "/product-categories/",
                        title: "Categorias",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "product-categories.index",
                                path: "/product-categories/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "product-categories.store",
                                path: "/product-categories/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: "physical-space",
                path: "/physical-space/",
                title: "Espaço Físico",
                icon: BsBuilding,
                breadcrumb: false,
                submenu: [
                    {
                        key: "building-types",
                        path: "/building-types",
                        title: "Tipos Prédios",
                        icon: FaRegBuilding,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "building-types.index",
                                path: "/buildings/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "building-types.store",
                                path: "/buildings/store",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "Rooms",
                        path: "/room-types/",
                        title: "Tipos de Salas",
                        icon: SiGoogleclassroom,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "room-types.index",
                                path: "/room-types/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "room-types.store",
                                path: "/room-types/index",
                                title: "Cadastrar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },

            {
                key: "site-management",
                path: "/site-management/",
                title: "Gestão do Site",
                icon: SettingOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "blog",
                        path: "/blog/",
                        title: "Blog",
                        icon: LaptopOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "posts",
                                path: "/posts",
                                title: "Posts",
                                icon: LayoutOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "posts.index",
                                        path: "/posts/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "posts.store",
                                        path: "/posts/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                            {
                                key: "post-categories",
                                path: "/post-categories/",
                                title: "Categorias",
                                icon: TagOutlined,
                                breadcrumb: false,
                                submenu: [
                                    {
                                        key: "post-categories.index",
                                        path: "/post-categories/index",
                                        title: "Listar",
                                        icon: OrderedListOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                    {
                                        key: "post-categories.store",
                                        path: "/post-categories/store",
                                        title: "Criar",
                                        icon: AppstoreAddOutlined,
                                        breadcrumb: false,
                                        submenu: [],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },

            {
                key: "reports",
                path: "/reports/",
                title: "Relatórios",
                icon: CalendarOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "academic-reports",
                        path: "/reports/academic/",
                        title: "Acadêmico",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.analytical-attendance-list",
                                path: "/reports/academic/frequency",
                                title: "Frequência",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.enrollment-scholarships",
                                path: "/reports/academic/scholarships",
                                title: "Bolsistas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.team",
                                path: "/reports/academic/teams",
                                title: "Gerencial de Turmas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.enrollment",
                                path: "/reports/academic/enrollment-analytics",
                                title: "Analítico de Matrículas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.synthetical-enrollments",
                                path: "/reports/academic/synthetical-enrollments",
                                title: "Sintético de Matrículas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-assessment",
                                path: "/reports/academic/evaluation-analytics",
                                title: "Analítico de Avaliações",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.grades",
                                path: "/reports/academic/grades",
                                title: "Notas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    //           {
                    //             key: "royalties-reports",
                    //             path: "/reports/royalties/",
                    //             title: "Royalties e Fundo de marca",
                    //             icon: TagOutlined,
                    //             breadcrumb: false,
                    //             submenu: [
                    //               {
                    //                 key: "reports.franchisor-royalties",
                    //                 path: "/reports/financial/franchisor-royalties",
                    //                 title: "Royalties",
                    //                 icon: OrderedListOutlined,
                    //                 breadcrumb: false,
                    //                 submenu: [],
                    //               },
                    //               // {
                    //               //   key: "reports.management-brand-funds",
                    //               //   path: "/reports/brand-funds/management-brand-funds",
                    //               //   title: "Gerencial de Fundo de Marca",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-enrollment",
                    //               //   path: "/reports/royalties/royalties-management",
                    //               //   title: "Gerencial de Royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-sale",
                    //               //   path: "/reports/royalties/royalties-analytics",
                    //               //   title: "Analítico de Royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //               // {
                    //               //   key: "reports.analytical-sale",
                    //               //   path: "/reports/royalties/invoice-management",
                    //               //   title: "Movimento de faturas de royalties",
                    //               //   icon: OrderedListOutlined,
                    //               //   breadcrumb: false,
                    //               //   submenu: [],
                    //               // },
                    //
                    //             ]
                    //           },
                    {
                        key: "sales-reports",
                        path: "/reports/sales/",
                        title: "Vendas",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.analytical-enrollment",
                                path: "/reports/sales/index",
                                title: "Gerencial de Vendas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-sale",
                                path: "/reports/sales/sales-analytics",
                                title: "Analítico de Vendas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.didactic-materials",
                                path: "/reports/sales/didactic-material",
                                title: "Materiais",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "financial-reports",
                        path: "/reports/financial/",
                        title: "Financeiro",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.franchisor-royalties",
                                path: "/reports/financial/franchisor-royalties",
                                title: "Royalties",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.cash-flow",
                                path: "/reports/financial/cash-flow",
                                title: "Fluxo Financeiro",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.financial-balance",
                                path: "/reports/financial/financial-balance",
                                title: "Balancete Financeiro",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            // {
                            //   key: "reports.financial-statement",
                            //   path: "/reports/financial/financial-statement",
                            //   title: "Extrato Financeiro",
                            //   icon: OrderedListOutlined,
                            //   breadcrumb: false,
                            //   submenu: [],
                            // },
                            {
                                key: "reports.invoice-statement",
                                path: "/reports/financial/invoice-statement",
                                title: "Extrato de Faturas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consolidated-receivables",
                                path: "/reports/financial/consolidated-receivables",
                                title: "Recebíveis Consolidados",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.withdraw-conciliation",
                                path: "/reports/financial/withdraw-conciliation",
                                title: "Conciliação de Saques",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consolidated-statements",
                                path: "/reports/financial/consolidated-statement",
                                title: "Extrato Consolidado",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.analytical-receipt",
                                path: "/reports/financial/analytical-incomes",
                                title: "Analítico de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },

                            {
                                key: "financial-reports-synthetical-incomes",
                                path: "/reports/financial/synthetical-incomes",
                                title: "Sintético de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.settled-consolidateds-statement",
                                path: "/reports/financial/settled",
                                title: "Consolidado de Liquidados",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.receipt",
                                path: "/reports/financial/revenue-manager",
                                title: "Gerencial de Receitas",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.defaulter",
                                path: "/reports/financial/defaulter",
                                title: "Inadimplência",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.bills-to-receive",
                                path: "/reports/financial/bills-receive",
                                title: "Contas a Receber no Período",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.forecast",
                                path: "/reports/financial/forecast",
                                title: "Forecast",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "access.reports",
                        path: "/reports/access/",
                        title: "Acesso",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.leads",
                                path: "/reports/access/leads",
                                title: "Leads",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.log-access",
                                path: "/reports/access/access-environment",
                                title: "Acessos ao Ambiente",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.manage-log-access",
                                path: "/reports/access/manage-access",
                                title: "Ger. de Acessos ao Ambiente",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                    {
                        key: "marketing",
                        path: "/reports/marketing/",
                        title: "Marketing",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "reports.follow-up",
                                path: "/reports/marketing/follow-up",
                                title: "Follow up",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.newsletter-contact-form",
                                path: "/reports/marketing/newsletter",
                                title: "Newsletter/Formulario de contato",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.manage-campaigns",
                                path: "/reports/marketing/campaigns",
                                title: "Gerencial de Campanha",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.consultant",
                                path: "/reports/marketing/consultants",
                                title: "Consultores",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "reports.birthday",
                                path: "/reports/marketing/birthdays",
                                title: "Aniversariantes",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: "reports.training",
                path: "/reports/",
                title: "Relatórios de Treinamento",
                icon: CalendarOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "reports.academic",
                        path: "/reports/academic/",
                        title: "Acadêmico",
                        icon: TagOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },
            {
                key: "configurations.index",
                path: "/configuration/",
                title: "Gestão Financeira",
                icon: SettingOutlined,
                breadcrumb: false,
                submenu: [
                    {
                        key: "configurations.index",
                        path: "/configuration/",
                        title: "Configuração",
                        icon: SettingOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "cash-flow.index",
                        path: "/cash-flow/index",
                        title: "Fluxo de Caixa",
                        icon: SlidersOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "suppliers",
                        path: "/providers/",
                        title: "Fornecedores",
                        icon: HddOutlined,
                        breadcrumb: false,
                        submenu: [
                            {
                                key: "suppliers.index",
                                path: "/providers/index",
                                title: "Listar",
                                icon: OrderedListOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                            {
                                key: "suppliers.store",
                                path: "/providers/store",
                                title: "Criar",
                                icon: AppstoreAddOutlined,
                                breadcrumb: false,
                                submenu: [],
                            },
                        ],
                    },

                    {
                        key: "current-accounts.index",
                        path: "/current_accounts/index",
                        title: "Contas Corrente",
                        icon: CreditCardOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "bills-to-pay.index",
                        path: "/bills-to-pay/",
                        title: "Contas a pagar",
                        icon: FileTextOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "accounts-payable.index",
                        path: "/bills-to-receive/",
                        title: "Contas a receber",
                        icon: FileTextOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },

                    {
                        key: "bill-categories.index",
                        path: "/bill-categories/",
                        title: "Categorias",
                        icon: ClusterOutlined,
                        breadcrumb: false,
                        submenu: [],
                    },
                ],
            },

            // {
            //   key: "leave",
            //   path: "/leave",
            //   title: "Sair",
            //   icon: LogoutOutlined,
            //   breadcrumb: false,
            //   submenu: [],
            // },
        ],
    },
];

const navigationConfig = [...franchiseeNavTree];

export default navigationConfig;
